// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"ZM-z","inlineTitle":"_M-z","sponsoredAdsWrapper":"aN-z","marketplaceRecosWrapper":"bN-z"};